export const PAGE_SHELL = {
  maxWidth: 1720,
  paddingX: { xs: 2, md: 3 },
  paddingLeft: { xs: 2, md: 3 },
  paddingRight: { xs: 2, md: 3 },
  paddingY: { xs: 0.5, md: 0.5 },
  headerMarginBottom: 1.5,
  sectionGap: 2,
} as const;

export const PAGE_TYPOGRAPHY = {
  heading: {
    fontSize: { xs: "2.25rem", md: "3rem" },
    fontWeight: 950,
    letterSpacing: 0,
    lineHeight: 1.05,
  },
} as const;

export const APP_LAYOUT = {
  appBarHeight: 86,
} as const;

export const BRAND_COLORS = {
  primary: {
    main: "#B87333",
    light: "#C99364",
    dark: "#8A5525",
    contrastText: "#ffffff",
    soft: "rgba(184, 115, 51, 0.10)",
    softSubtle: "rgba(184, 115, 51, 0.08)",
    softHover: "rgba(184, 115, 51, 0.12)",
    softStrong: "rgba(184, 115, 51, 0.25)",
    border: "rgba(184, 115, 51, 0.24)",
    focusRing: "rgba(184, 115, 51, 0.15)",
    shadow: "rgba(138, 85, 37, 0.16)",
    shadowHover: "rgba(138, 85, 37, 0.22)",
    shadowStrong: "rgba(184, 115, 51, 0.28)",
  },
} as const;

export const UI_RADIUS = {
  button: "12px",
  card: "8px",
  panel: "8px",
  input: "10px",
  chip: "999px",
  iconButton: "999px",
} as const;
